import { render, staticRenderFns } from "./stockDetail.vue?vue&type=template&id=ec6c0b2c&scoped=true"
import script from "./stockDetail.vue?vue&type=script&lang=js"
export * from "./stockDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6c0b2c",
  null
  
)

export default component.exports